import React from "react";
import Navbar from "./components/Navbar";
import VideoHero from "./components/VideoHero";
import EventStrip from "./components/EventStrip";
import About from "./components/About";
import HowItWorks from "./components/HowItWorks";
import Offers from "./components/Offers";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const App: React.FC = () => {
  return (
    <div className="bg-black text-white min-h-screen font-body">
      <Navbar />
      <VideoHero />
      <EventStrip />
      <About />
      <HowItWorks />
      <Offers />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
